<template>
    <div class="row no-padding">
        <div class="col-xs-12 no-padding-bottom no-margin-bottom">
            <button
                    v-on:click="formShown = !formShown"
                    v-bind:disabled="formShown"
                    class="btn btn-primary full-width">
                {{ 'Impossible' | trans }}
            </button>

            <JobImpossibleForm
                    v-if="formShown"
                    v-bind:job="job"
                    v-bind:user="user"
                    v-on:form:submitted="$emit('confirmed', job)"
                    v-on:form:cancelled="formShown = false">
            </JobImpossibleForm>
        </div>
    </div>
</template>

<script>
    import JobImpossibleForm from './JobImpossibleForm';

    export default {
        components: {JobImpossibleForm},
        props: {
            job: Object,
            user: Object
        },
        data() {
            return {
                formShown: false,
            };
        },
    }
</script>
